export default function AgendaCategoryDirective() {
  return {
    template: require('./agenda-category.html'),
    scope: {
      category: '=',
      agendaIsActive: '=',
      canEdit: '=',
      canDelete: '=',
      canChangeStatus: '='
    },
    controller: 'AgendaCategoryController',
    controllerAs: 'agendaCategoryVM',

    bindToController: true,
    replace: true
  };
}
